// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"bbe7bf07","180":"87c10c0f","188":"017c7026","218":"bfd99a5b","238":"6520f109","294":"1ef6715e","453":"0897d8d2","589":"4c3b09a4","651":"700de290","668":"7bdc7754"}[chunkId] + ".chunk.js";
};